(function () {
  function setActiveSwatch(card, swatch) {
    card.querySelectorAll('[data-swatch]').forEach(function (item) {
      item.classList.remove('is-active');
    });

    if (swatch) {
      swatch.classList.add('is-active');
    }
  }

  function getMainImage(card) {
    return card ? card.querySelector('[data-card-main-image]') : null;
  }

  function swapCardImage(card, swatch, lockSelection) {
    if (!card || !swatch) return;
    if (card.querySelector('[data-swatchbro-card]')) return;

    var img = getMainImage(card);
    if (!img) return;

    var newSrc = swatch.getAttribute('data-image-src');
    var newSrcset = swatch.getAttribute('data-image-srcset');

    if (!newSrc) return;

    img.setAttribute('src', newSrc);
    if (newSrcset) {
      img.setAttribute('srcset', newSrcset);
    }

    setActiveSwatch(card, swatch);

    if (lockSelection) {
      card.setAttribute('data-locked-swatch-src', newSrc);
      card.setAttribute('data-locked-swatch-srcset', newSrcset || '');
      card.setAttribute('data-locked-swatch-color', swatch.getAttribute('data-color') || '');
    }
  }

  function restoreDefaultImage(card) {
    if (!card) return;
    if (card.querySelector('[data-swatchbro-card]')) return;

    var img = getMainImage(card);
    if (!img) return;

    var defaultSrc = img.getAttribute('data-default-src');
    var defaultSrcset = img.getAttribute('data-default-srcset');

    if (defaultSrc) img.setAttribute('src', defaultSrc);
    if (defaultSrcset) img.setAttribute('srcset', defaultSrcset);

    setActiveSwatch(card, null);
  }

  function restoreLockedOrDefault(card) {
    if (!card) return;
    if (card.querySelector('[data-swatchbro-card]')) return;

    var img = getMainImage(card);
    if (!img) return;

    var lockedSrc = card.getAttribute('data-locked-swatch-src');
    var lockedSrcset = card.getAttribute('data-locked-swatch-srcset');
    var lockedColor = card.getAttribute('data-locked-swatch-color');

    if (lockedSrc) {
      img.setAttribute('src', lockedSrc);
      if (lockedSrcset) img.setAttribute('srcset', lockedSrcset);

      var lockedSwatch = null;
      card.querySelectorAll('[data-swatch]').forEach(function (item) {
        if ((item.getAttribute('data-color') || '') === (lockedColor || '')) {
          lockedSwatch = item;
        }
      });

      setActiveSwatch(card, lockedSwatch);
      return;
    }

    restoreDefaultImage(card);
  }

  function getSwatchFromEvent(event) {
    return event.target && event.target.closest ? event.target.closest('[data-swatch]') : null;
  }

  document.addEventListener(
    'pointerdown',
    function (event) {
      var swatch = getSwatchFromEvent(event);
      if (!swatch) return;

      event.preventDefault();
      event.stopPropagation();
      if (typeof event.stopImmediatePropagation === 'function') {
        event.stopImmediatePropagation();
      }
    },
    true
  );

  document.addEventListener(
    'click',
    function (event) {
      var swatch = getSwatchFromEvent(event);
      if (!swatch) return;

      event.preventDefault();
      event.stopPropagation();
      if (typeof event.stopImmediatePropagation === 'function') {
        event.stopImmediatePropagation();
      }

      var card = swatch.closest('[data-product-card]');
      if (!card) return;

      swapCardImage(card, swatch, true);
    },
    true
  );

  document.addEventListener(
    'pointerover',
    function (event) {
      if (!window.matchMedia('(hover: hover)').matches) return;

      var swatch = getSwatchFromEvent(event);
      if (!swatch) return;

      var card = swatch.closest('[data-product-card]');
      if (!card) return;

      swapCardImage(card, swatch, false);
    },
    true
  );

  document.addEventListener(
    'focusin',
    function (event) {
      var swatch = getSwatchFromEvent(event);
      if (!swatch) return;

      var card = swatch.closest('[data-product-card]');
      if (!card) return;

      swapCardImage(card, swatch, false);
    },
    true
  );

  document.addEventListener(
    'mouseout',
    function (event) {
      if (!window.matchMedia('(hover: hover)').matches) return;

      var card = event.target && event.target.closest ? event.target.closest('[data-product-card]') : null;
      if (!card) return;

      var related = event.relatedTarget;
      if (related && card.contains(related)) return;

      restoreLockedOrDefault(card);
    },
    true
  );
})();
